<template>
  <v-row class="mx-4" no-gutters>
    <v-col cols="12" class="py-0 d-flex align-center flex-wrap">
      <div style="line-height: 1;">
        <span v-if="title" class="text-title-small">Document</span>
        <div v-else class="body-2">
          {{ activityName }}
          <span v-if="documentType" class="ml-1">({{ documentType }})</span>
        </div>
        <div v-if="activity.isDraft" class="caption">
          <span>(Draft)</span>
        </div>
      </div>
      <template v-if="!mobile">
        <v-spacer />
        <div class="ml-sm-2 mr-2">
          <span v-if="title" class="text-title-small">Old Price</span>
          <span v-else class="fs-exclude text-h6 font-weight-regular">{{ activity.oldPrice | dollarDisplay }}</span>
        </div>
        <div v-if="title" style="width: 24px;" />
        <v-icon v-if="!title">
          keyboard_arrow_right
        </v-icon>
        <div class="ml-sm-2 mr-2">
          <span v-if="title" class="text-title-small">New Price</span>
          <span v-else class="fs-exclude text-h6">{{ activity.newPrice | dollarDisplay }}</span>
        </div>
      </template>
    </v-col>
    <v-col v-if="mobile" :cols="12" class="d-flex">
      <div class="ml-sm-2 mr-2">
        <span v-if="title" class="text-title-small">Old Price</span>
        <span v-else class="fs-exclude text-h6 font-weight-regular">{{ activity.oldPrice | dollarDisplay }}</span>
      </div>
      <div v-if="title" style="width: 24px;" />
      <v-icon v-if="!title">
        keyboard_arrow_right
      </v-icon>
      <div class="ml-sm-2 mr-2">
        <span v-if="title" class="text-title-small">New Price</span>
        <span v-else class="fs-exclude text-h6">{{ activity.newPrice | dollarDisplay }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    activity: { type: Object, default: () => ({}) },
    documentsRemoved: { type: Boolean, default: false },
    jobStatus: { type: String, default: 'draft' },
    title: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false }
  },
  data() {
    return {
      removeModal: false
    }
  },
  computed: {
    activityName() {
      return this.activity.templateTypeName
    },
    documentType() {
      switch (this.activity.documentType) {
        case 'customer-template':
          return 'Self-Service'
        case 'provider-template':
          return 'Standard'
        default:
          return null
      }
    }
  }
}
</script>
